import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

// export const Barcode = ({ htmlId = '', value = '123456789012', format = 'CODE128' }) => {
//     const svgRef = useRef(null);

//     useEffect(() => {
//         if (svgRef.current) {
//             JsBarcode(svgRef.current, value, {
//                 format,
//                 lineColor: '#000',
//                 width: 2,
//                 height: 80,
//                 displayValue: true,
//                 fontSize: 14,
//                 margin: 10,
//             });
//         }
//     }, [value, format]);

//     return <svg id={htmlId} ref={svgRef} />;
// };


export const Barcode = ({ htmlId = '', value = '123456789012', format = 'CODE128' }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            JsBarcode(canvasRef.current, value, {
                format,
                lineColor: '#000',
                width: 2,
                height: 80,
                displayValue: false,
                fontSize: 14,
                margin: 10,
            });
        }
    }, [value, format]);

    return <canvas id={htmlId} ref={canvasRef} />;
};

// export const svgToPngDataUrl = (svgElement) => {
//     const svgData = new XMLSerializer().serializeToString(svgElement);
//     const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
//     const url = URL.createObjectURL(svgBlob);

//     const canvas = document.createElement('canvas');
//     canvas.width = svgElement.clientWidth;
//     canvas.height = svgElement.clientHeight;
//     const ctx = canvas.getContext('2d');

//     return new Promise((resolve) => {
//         const img = new Image();
//         img.onload = function () {
//             ctx.drawImage(img, 0, 0);
//             URL.revokeObjectURL(url);
//             resolve(canvas.toDataURL('image/png'));
//         };
//         img.src = url;
//     });
// }

export const svgToPngDataUrl = ({ id }) => {

    const svgElement = document.getElementById(id);
    if (!svgElement) {
        console.warn(`SVG with id ${id} not found`);
        return null;
    }

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    const canvas = document.createElement('canvas');
    canvas.width = svgElement.clientWidth || 300;
    canvas.height = svgElement.clientHeight || 100;
    const ctx = canvas.getContext('2d');

    return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => {
            console.error('Failed to load image from SVG');
            resolve(null);
        };
        img.src = url;
    });
}